// import React, { useState, useEffect } from 'react';
// import { Base_Url } from '../config';
// import "./AdminContactManager.css"

// const ContactManagementSystem = () => {
//     const [sections, setSections] = useState([]);
//     const [selectedSection, setSelectedSection] = useState(null);
    
//     const [sectionForm, setSectionForm] = useState({
//         title: '',
//         column_position: 'left',
//         display_order: 0
//     });
//     const [contactForm, setContactForm] = useState({
//         name: '',
//         designation: '',
//         landline: '',
//         email: '',
//         display_order: 0
//     });
//     const [activeTab, setActiveTab] = useState('sections');
//     const [loading, setLoading] = useState(false);
//     const [message, setMessage] = useState({ type: '', text: '' });
    
//     // States for inline editing
//     const [editingSection, setEditingSection] = useState(null);
//     const [editingContact, setEditingContact] = useState(null);
//     const [editSectionForm, setEditSectionForm] = useState({
//         title: '',
//         column_position: 'left',
//         display_order: 0
//     });
//     const [editContactForm, setEditContactForm] = useState({
//         name: '',
//         designation: '',
//         landline: '',
//         email: '',
//         display_order: 0
//     });

//     useEffect(() => {
//         fetchSections();
//     }, []);

//     const showMessage = (type, text) => {
//         setMessage({ type, text });
//         setTimeout(() => setMessage({ type: '', text: '' }), 3000);
//     };

//     const fetchSections = async () => {
//         setLoading(true);
//         try {
//             const response = await fetch(`${Base_Url}/sections`);
//             if (!response.ok) throw new Error('Failed to fetch sections');
//             const data = await response.json();
//             setSections(data);
//             setLoading(false);
//         } catch (error) {
//             console.error('Error fetching sections:', error);
//             showMessage('error', 'Failed to load sections');
//             setLoading(false);
//         }
//     };

//     const fetchSectionDetails = async (sectionId) => {
//         try {
//             const response = await fetch(`${Base_Url}/sections/${sectionId}`);
//             if (!response.ok) throw new Error('Failed to fetch section details');
//             return await response.json();
//         } catch (error) {
//             console.error('Error fetching section details:', error);
//             showMessage('error', 'Failed to load section details');
//             return null;
//         }
//     };

//     const handleSectionSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);
        
//         try {
//             const response = await fetch(`${Base_Url}/sections`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify(sectionForm)
//             });
            
//             if (!response.ok) throw new Error('Failed to save section');
            
//             const result = await response.json();
//             showMessage('success', 'Section created successfully');
//             setSectionForm({ title: '', column_position: 'left', display_order: 0 });
//             fetchSections();
//         } catch (error) {
//             console.error('Error saving section:', error);
//             showMessage('error', 'Failed to save section');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleContactSubmit = async (e) => {
//         e.preventDefault();
//         if (!selectedSection) {
//             showMessage('error', 'Please select a section first');
//             return;
//         }
        
//         setLoading(true);
        
//         try {
//             const response = await fetch(`${Base_Url}/entries`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify({
//                     ...contactForm,
//                     section_id: selectedSection.id
//                 })
//             });
            
//             if (!response.ok) throw new Error('Failed to save contact');
            
//             showMessage('success', 'Contact added successfully');
//             setContactForm({ name: '', designation: '', landline: '', email: '', display_order: 0 });
            
//             // Refresh the selected section with updated contacts
//             const updatedSection = await fetchSectionDetails(selectedSection.id);
//             if (updatedSection) {
//                 setSelectedSection(updatedSection);
//             }
            
//             fetchSections();
//         } catch (error) {
//             console.error('Error saving contact:', error);
//             showMessage('error', 'Failed to save contact');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const deleteSection = async (id) => {
//         if (!window.confirm('Are you sure you want to delete this section? This will also delete all contacts within it.')) {
//             return;
//         }
        
//         setLoading(true);
//         try {
//             const response = await fetch(`${Base_Url}/sections/${id}`, { method: 'DELETE' });
//             if (!response.ok) throw new Error('Failed to delete section');
            
//             showMessage('success', 'Section deleted successfully');
//             setSelectedSection(null);
//             fetchSections();
//         } catch (error) {
//             console.error('Error deleting section:', error);
//             showMessage('error', 'Failed to delete section');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const deleteContact = async (contactId) => {
//         if (!window.confirm('Are you sure you want to delete this contact?')) {
//             return;
//         }
        
//         setLoading(true);
//         try {
//             const response = await fetch(`${Base_Url}/entries/${contactId}`, { method: 'DELETE' });
//             if (!response.ok) throw new Error('Failed to delete contact');
            
//             showMessage('success', 'Contact deleted successfully');
            
//             // Refresh the selected section with updated contacts
//             if (selectedSection) {
//                 const updatedSection = await fetchSectionDetails(selectedSection.id);
//                 if (updatedSection) {
//                     setSelectedSection(updatedSection);
//                 }
//             }
            
//             fetchSections();
//         } catch (error) {
//             console.error('Error deleting contact:', error);
//             showMessage('error', 'Failed to delete contact');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleSectionSelect = async (section) => {
//         setSelectedSection(section);
//         setActiveTab('contacts');
        
//         // Fetch full section details with contacts
//         const sectionDetails = await fetchSectionDetails(section.id);
//         if (sectionDetails) {
//             setSelectedSection(sectionDetails);
//         }
//     };

//     // Inline editing functions for sections
//     const startEditingSection = (section) => {
//         setEditingSection(section.id);
//         setEditSectionForm({
//             title: section.title,
//             column_position: section.column_position,
//             display_order: section.display_order
//         });
//     };

//     const cancelEditingSection = () => {
//         setEditingSection(null);
//         setEditSectionForm({
//             title: '',
//             column_position: 'left',
//             display_order: 0
//         });
//     };

//     const updateSection = async (id) => {
//         setLoading(true);
//         try {
//             const response = await fetch(`${Base_Url}/sections/${id}`, {
//                 method: 'PUT',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify(editSectionForm)
//             });
            
//             if (!response.ok) throw new Error('Failed to update section');
            
//             showMessage('success', 'Section updated successfully');
//             setEditingSection(null);
//             fetchSections();
//         } catch (error) {
//             console.error('Error updating section:', error);
//             showMessage('error', 'Failed to update section');
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Inline editing functions for contacts
//     const startEditingContact = (contact) => {
//         setEditingContact(contact.id);
//         setEditContactForm({
//             name: contact.name,
//             designation: contact.designation,
//             landline: contact.landline,
//             email: contact.email,
//             display_order: contact.display_order
//         });
//     };

//     const cancelEditingContact = () => {
//         setEditingContact(null);
//         setEditContactForm({
//             name: '',
//             designation: '',
//             landline: '',
//             email: '',
//             display_order: 0
//         });
//     };

//     const updateContact = async (contactId) => {
//         setLoading(true);
//         try {
//             const response = await fetch(`${Base_Url}/entries/${contactId}`, {
//                 method: 'PUT',
//                 headers: {
//                     'Content-Type': 'application/json',
//                 },
//                 body: JSON.stringify({
//                     ...editContactForm,
//                     section_id: selectedSection.id
//                 })
//             });
            
//             if (!response.ok) throw new Error('Failed to update contact');
            
//             showMessage('success', 'Contact updated successfully');
//             setEditingContact(null);
            
//             // Refresh the selected section with updated contacts
//             if (selectedSection) {
//                 const updatedSection = await fetchSectionDetails(selectedSection.id);
//                 if (updatedSection) {
//                     setSelectedSection(updatedSection);
//                 }
//             }
            
//             fetchSections();
//         } catch (error) {
//             console.error('Error updating contact:', error);
//             showMessage('error', 'Failed to update contact');
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="cms-container my-4">
//             <h2 className="page-title mb-4 border-bottom-0 mb-0 pb-0">
//             Contact Management  <span className="highlight-title">System</span>
//           </h2>
            
//             {message.text && (
//                 <div className={`cms-alert cms-alert-${message.type === 'error' ? 'danger' : 'success'} alert-dismissible fade show`}>
//                     {message.text}
//                     <button type="button" className="cms-alert-close" onClick={() => setMessage({ type: '', text: '' })}></button>
//                 </div>
//             )}
            
//             {loading && (
//                 <div className="cms-loading text-center my-4">
//                     <div className="cms-spinner" role="status">
//                         <span className="cms-visually-hidden">Loading...</span>
//                     </div>
//                 </div>
//             )}
            
//             <ul className="cms-nav cms-nav-tabs mb-3">
//                 <li className="cms-nav-item">
//                     <button 
//                         className={`cms-nav-link ${activeTab === 'sections' ? 'cms-active' : ''}`}
//                         onClick={() => setActiveTab('sections')}
//                     >
//                         Sections
//                     </button>
//                 </li>
//                 <li className="cms-nav-item">
//                     <button 
//                         className={`cms-nav-link ${activeTab === 'contacts' ? 'cms-active' : ''}`}
//                         onClick={() => setActiveTab('contacts')}
//                     >
//                         Contacts
//                     </button>
//                 </li>
//             </ul>
            
//             <div className="cms-row">
//                 <div className="cms-col-md-4">
//                     <div className="cms-section-list">
//                         {sections.map(section => (
//                             <button
//                                 key={section.id}
//                                 className={`cms-section-item ${selectedSection?.id === section.id ? 'cms-active-section' : ''}`}
//                                 onClick={() => handleSectionSelect(section)}
//                             >
//                                 <div className="cms-section-content">
//                                     <span className="cms-section-title">{section.title}</span>
//                                     <div className="cms-section-badges">
//                                         <span className="cms-section-badge cms-position-badge">
//                                             {section.column_position}
//                                         </span>
//                                         <span className="cms-section-badge cms-contact-count-badge">
//                                             {section.contacts_count || 0} contacts
//                                         </span>
//                                     </div>
//                                 </div>
//                             </button>
//                         ))}
//                     </div>
                    
//                     {activeTab === 'sections' && (
//                         <div className="cms-section-form mt-3">
//                             <h4 className="cms-form-title">Add New Section</h4>
//                             <form onSubmit={handleSectionSubmit}>
//                                 <div className="cms-form-group">
//                                     <label className="cms-form-label">Title *</label>
//                                     <input
//                                         type="text"
//                                         className="cms-form-control"
//                                         value={sectionForm.title}
//                                         onChange={(e) => setSectionForm({...sectionForm, title: e.target.value})}
//                                         required
//                                     />
//                                 </div>
//                                 <div className="cms-form-group">
//                                     <label className="cms-form-label">Column Position</label>
//                                     <select
//                                         className="cms-form-select"
//                                         value={sectionForm.column_position}
//                                         onChange={(e) => setSectionForm({...sectionForm, column_position: e.target.value})}
//                                     >
//                                         <option value="left">Left</option>
//                                         <option value="right">Right</option>
//                                     </select>
//                                 </div>
//                                 {/* <div className="cms-form-group">
//                                     <label className="cms-form-label">Display Order</label>
//                                     <input
//                                         type="number"
//                                         className="cms-form-control"
//                                         value={sectionForm.display_order}
//                                         onChange={(e) => setSectionForm({...sectionForm, display_order: parseInt(e.target.value) || 0})}
//                                     />
//                                 </div> */}
//                                 <button 
//                                     type="submit" 
//                                     className="cms-btn cms-btn-primary"
//                                     disabled={loading}
//                                 >
//                                     Add Section
//                                 </button>
//                             </form>
//                         </div>
//                     )}
//                 </div>
                
//                 <div className="cms-col-md-8">
//                     {activeTab === 'sections' && (
//                         <div>
//                             <h4 className="cms-manage-title">Manage Sections</h4>
//                             {sections.length === 0 ? (
//                                 <div className="cms-info-alert">
//                                     No sections found. Create your first section using the form on the left.
//                                 </div>
//                             ) : (
//                                 <div className="cms-table-container">
//                                     <table className="cms-table">
//                                         <thead>
//                                             <tr>
//                                                 <th>Title</th>
//                                                 <th>Position</th>
//                                                 <th>Contacts</th>
//                                                 <th>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {sections.map(section => (
//                                                 <tr key={section.id}>
//                                                     <td  style={{fontSize:"13px"}}>
//                                                         {editingSection === section.id ? (
//                                                             <input
//                                                                 type="text"
//                                                                 className="cms-form-control cms-inline-input"
//                                                                 value={editSectionForm.title}
//                                                                 onChange={(e) => setEditSectionForm({...editSectionForm, title: e.target.value})}
//                                                             />
//                                                         ) : (
//                                                             section.title
//                                                         )}
//                                                     </td>
//                                                     <td  style={{fontSize:"13px"}}>
//                                                         {editingSection === section.id ? (
//                                                             <select
//                                                                 className="cms-form-select cms-inline-select"
//                                                                 value={editSectionForm.column_position}
//                                                                 onChange={(e) => setEditSectionForm({...editSectionForm, column_position: e.target.value})}
//                                                             >
//                                                                 <option value="left">Left</option>
//                                                                 <option value="right">Right</option>
//                                                             </select>
//                                                         ) : (
//                                                             section.column_position
//                                                         )}
//                                                     </td>
//                                                     <td  style={{fontSize:"13px"}}>
//                                                         <span className="cms-contact-badge">
//                                                             {section.contacts_count || 0}
//                                                         </span>
//                                                     </td>
//                                                     <td  style={{fontSize:"13px"}}>
//                                                         {editingSection === section.id ? (
//                                                             <div className="cms-inline-actions">
//                                                                 <button 
//                                                                     className="cms-btn cms-btn-success cms-btn-sm"
//                                                                     onClick={() => updateSection(section.id)}
//                                                                     disabled={loading}
//                                                                 >
//                                                                     Save
//                                                                 </button>
//                                                                 <button 
//                                                                     className="cms-btn cms-btn-secondary cms-btn-sm"
//                                                                     onClick={cancelEditingSection}
//                                                                     disabled={loading}
//                                                                 >
//                                                                     Cancel
//                                                                 </button>
//                                                             </div>
//                                                         ) : (
//                                                             <div className="cms-inline-actions">
//                                                                 <button 
//                                                                     className="cms-btn cms-btn-primary cms-btn-sm"
//                                                                     onClick={() => startEditingSection(section)}
//                                                                     disabled={loading}
//                                                                 >
//                                                                     Edit
//                                                                 </button>
//                                                                 <button 
//                                                                     className="cms-btn cms-btn-danger cms-btn-sm"
//                                                                     onClick={() => deleteSection(section.id)}
//                                                                     disabled={loading}
//                                                                 >
//                                                                     Delete
//                                                                 </button>
//                                                             </div>
//                                                         )}
//                                                     </td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             )}
//                         </div>
//                     )}
                    
//                     {activeTab === 'contacts' && (
//                         <div>
//                             {selectedSection ? (
//                                 <>
//                                     <h4 className="cms-contact-header">Manage Contacts in: {selectedSection.title}</h4>
//                                     <div className="cms-contact-card">
//                                         <div className="cms-card-header">
//                                             <h5 className="cms-card-title">Add New Contact</h5>
//                                         </div>
//                                         <div className="cms-card-body">
//                                             <form onSubmit={handleContactSubmit}>
//                                                 <div className="cms-form-row">
//                                                     <div className="cms-form-col-6">
//                                                         <label className="cms-form-label">Name *</label>
//                                                         <input
//                                                             type="text"
//                                                             className="cms-form-control"
//                                                             value={contactForm.name}
//                                                             onChange={(e) => setContactForm({...contactForm, name: e.target.value})}
//                                                             required
//                                                         />
//                                                     </div>
//                                                     <div className="cms-form-col-6">
//                                                         <label className="cms-form-label">Designation</label>
//                                                         <input
//                                                             type="text"
//                                                             className="cms-form-control"
//                                                             value={contactForm.designation}
//                                                             onChange={(e) => setContactForm({...contactForm, designation: e.target.value})}
//                                                         />
//                                                     </div>
//                                                     <div className="cms-form-col-6">
//                                                         <label className="cms-form-label">Landline</label>
//                                                         <input
//                                                             type="text"
//                                                             className="cms-form-control"
//                                                             value={contactForm.landline}
//                                                             onChange={(e) => setContactForm({...contactForm, landline: e.target.value})}
//                                                         />
//                                                     </div>
//                                                     <div className="cms-form-col-6">
//                                                         <label className="cms-form-label">Email</label>
//                                                         <input
//                                                             type="email"
//                                                             style={{textTransform: "lowercase"}}
//                                                             className="cms-form-control"
//                                                             value={contactForm.email}
//                                                             onChange={(e) => setContactForm({...contactForm, email: e.target.value})}
//                                                         />
//                                                     </div>
//                                                     {/* <div className="cms-form-col-6">
//                                                         <label className="cms-form-label">Display Order</label>
//                                                         <input
//                                                             type="number"
//                                                             className="cms-form-control"
//                                                             value={contactForm.display_order}
//                                                             onChange={(e) => setContactForm({...contactForm, display_order: parseInt(e.target.value) || 0})}
//                                                         />
//                                                     </div> */}
//                                                     <div className="cms-form-col-12">
//                                                         <button 
//                                                             type="submit" 
//                                                             className="cms-btn cms-btn-primary"
//                                                             disabled={loading}
//                                                         >
//                                                             Add Contact
//                                                         </button>
//                                                     </div>
//                                                 </div>
//                                             </form>
//                                         </div>
//                                     </div>
                                    
//                                     <h5 className="cms-existing-contacts">Existing Contacts</h5>
//                                     {selectedSection.contacts && selectedSection.contacts.length === 0 ? (
//                                         <div className="cms-info-alert">
//                                             No contacts in this section yet. Add your first contact using the form above.
//                                         </div>
//                                     ) : (
//                                         <div className="cms-table-container">
//                                             <table className="cms-table">
//                                                 <thead>
//                                                     <tr  style={{fontSize:"13px"}}>
//                                                         <th>Name</th>
//                                                         <th>Designation</th>
//                                                         <th>Landline</th>
//                                                         <th style={{textTransform: "lowercase"}}>Email</th>
//                                                         <th>Order</th>
//                                                         <th>Actions</th>
//                                                     </tr>
//                                                 </thead>
//                                                 <tbody>
//                                                     {selectedSection.contacts && selectedSection.contacts.map(contact => (
//                                                         <tr key={contact.id} style={{fontSize:"13px"}}>
//                                                             <td  style={{fontSize:"13px"}}>
//                                                                 {editingContact === contact.id ? (
//                                                                     <input
//                                                                         type="text"
//                                                                         className="cms-form-control cms-inline-input"
//                                                                         value={editContactForm.name}
//                                                                         onChange={(e) => setEditContactForm({...editContactForm, name: e.target.value})}
//                                                                     />
//                                                                 ) : (
//                                                                     contact.name
//                                                                 )}
//                                                             </td>
//                                                             <td  style={{fontSize:"13px"}}>
//                                                                 {editingContact === contact.id ? (
//                                                                     <input
//                                                                         type="text"
//                                                                         className="cms-form-control cms-inline-input"
//                                                                         value={editContactForm.designation}
//                                                                         onChange={(e) => setEditContactForm({...editContactForm, designation: e.target.value})}
//                                                                     />
//                                                                 ) : (
//                                                                     contact.designation || '-'
//                                                                 )}
//                                                             </td>
//                                                             <td  style={{fontSize:"13px"}}>
//                                                                 {editingContact === contact.id ? (
//                                                                     <input
//                                                                         type="text"
//                                                                         className="cms-form-control cms-inline-input"
//                                                                         value={editContactForm.landline}
//                                                                         onChange={(e) => setEditContactForm({...editContactForm, landline: e.target.value})}
//                                                                     />
//                                                                 ) : (
//                                                                     contact.landline || '-'
//                                                                 )}
//                                                             </td>
//                                                             <td  style={{fontSize:"13px"}}>
//                                                                 {editingContact === contact.id ? (
//                                                                     <input
//                                                                         type="email"
//                                                                         style={{textTransform: "lowercase !important"}}
//                                                                         className="cms-form-control cms-inline-input"
//                                                                         value={editContactForm.email}
//                                                                         onChange={(e) => setEditContactForm({...editContactForm, email: e.target.value})}
//                                                                     />
//                                                                 ) : (
//                                                                     <span style={{textTransform: "lowercase"}}>

//                                                                   {  contact.email || '-'}
//                                                                      </span>
//                                                                 )}
//                                                             </td>
//                                                             <td  style={{fontSize:"13px"}}>
//                                                                 {editingContact === contact.id ? (
//                                                                     <input
//                                                                         type="number"
//                                                                         className="cms-form-control cms-inline-input"
//                                                                         value={editContactForm.display_order}
//                                                                         onChange={(e) => setEditContactForm({...editContactForm, display_order: parseInt(e.target.value) || 0})}
//                                                                     />
//                                                                 ) : (
//                                                                     contact.display_order
//                                                                 )}
//                                                             </td>
//                                                             <td  style={{fontSize:"13px"}}>
//                                                                 {editingContact === contact.id ? (
//                                                                     <div className="cms-inline-actions">
//                                                                         <button 
//                                                                             className="cms-btn cms-btn-success cms-btn-sm"
//                                                                             onClick={() => updateContact(contact.id)}
//                                                                             disabled={loading}
//                                                                         >
//                                                                             Save
//                                                                         </button>
//                                                                         <button 
//                                                                             className="cms-btn cms-btn-secondary cms-btn-sm"
//                                                                             onClick={cancelEditingContact}
//                                                                             disabled={loading}
//                                                                         >
//                                                                             Cancel
//                                                                         </button>
//                                                                     </div>
//                                                                 ) : (
//                                                                     <div className="cms-inline-actions">
//                                                                         <button 
//                                                                             className="cms-btn cms-btn-primary cms-btn-sm"
//                                                                             onClick={() => startEditingContact(contact)}
//                                                                             disabled={loading}
//                                                                         >
//                                                                             Edit
//                                                                         </button>
//                                                                         <button 
//                                                                             className="cms-btn cms-btn-danger cms-btn-sm"
//                                                                             onClick={() => deleteContact(contact.id)}
//                                                                             disabled={loading}
//                                                                         >
//                                                                             Delete
//                                                                         </button>
//                                                                     </div>
//                                                                 )}
//                                                             </td>
//                                                         </tr>
//                                                     ))}
//                                                 </tbody>
//                                             </table>
//                                         </div>
//                                     )}
//                                 </>
//                             ) : (
//                                 <div className="cms-info-alert">
//                                     Please select a section from the left to manage its contacts.
//                                 </div>
//                             )}
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default ContactManagementSystem;


import React, { useState, useEffect } from 'react';
import { Base_Url } from '../config';
import "./AdminContactManager.css"

const ContactManagementSystem = () => {
    const [sections, setSections] = useState([]);
    const [selectedSection, setSelectedSection] = useState(null);
    
    const [sectionForm, setSectionForm] = useState({
        title: '',
        column_position: 'left',
        display_order: 0,
        email: ''
    });
    const [contactForm, setContactForm] = useState({
        name: '',
        designation: '',
        landline: '',
        email: '',
        display_order: 0
    });
    const [activeTab, setActiveTab] = useState('sections');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });
    
    // States for inline editing
    const [editingSection, setEditingSection] = useState(null);
    const [editingContact, setEditingContact] = useState(null);
    const [editSectionForm, setEditSectionForm] = useState({
        title: '',
        column_position: 'left',
        display_order: 0,
        email: ''
    });
    const [editContactForm, setEditContactForm] = useState({
        name: '',
        designation: '',
        landline: '',
        email: '',
        display_order: 0
    });

    useEffect(() => {
        fetchSections();
    }, []);

    const showMessage = (type, text) => {
        setMessage({ type, text });
        setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    };

    const fetchSections = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${Base_Url}/sections`);
            if (!response.ok) throw new Error('Failed to fetch sections');
            const data = await response.json();
            setSections(data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching sections:', error);
            showMessage('error', 'Failed to load sections');
            setLoading(false);
        }
    };

    const fetchSectionDetails = async (sectionId) => {
        try {
            const response = await fetch(`${Base_Url}/sections/${sectionId}`);
            if (!response.ok) throw new Error('Failed to fetch section details');
            return await response.json();
        } catch (error) {
            console.error('Error fetching section details:', error);
            showMessage('error', 'Failed to load section details');
            return null;
        }
    };

    const handleSectionSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        
        try {
            const response = await fetch(`${Base_Url}/sections`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(sectionForm)
            });
            
            if (!response.ok) throw new Error('Failed to save section');
            
            const result = await response.json();
            showMessage('success', 'Section created successfully');
            setSectionForm({ 
                title: '', 
                column_position: 'left', 
                display_order: 0,
                email: '' 
            });
            fetchSections();
        } catch (error) {
            console.error('Error saving section:', error);
            showMessage('error', 'Failed to save section');
        } finally {
            setLoading(false);
        }
    };

    const handleContactSubmit = async (e) => {
        e.preventDefault();
        if (!selectedSection) {
            showMessage('error', 'Please select a section first');
            return;
        }
        
        setLoading(true);
        
        try {
            const response = await fetch(`${Base_Url}/entries`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...contactForm,
                    section_id: selectedSection.id
                })
            });
            
            if (!response.ok) throw new Error('Failed to save contact');
            
            showMessage('success', 'Contact added successfully');
            setContactForm({ 
                name: '', 
                designation: '', 
                landline: '', 
                email: '', 
                display_order: 0 
            });
            
            // Refresh the selected section with updated contacts
            const updatedSection = await fetchSectionDetails(selectedSection.id);
            if (updatedSection) {
                setSelectedSection(updatedSection);
            }
            
            fetchSections();
        } catch (error) {
            console.error('Error saving contact:', error);
            showMessage('error', 'Failed to save contact');
        } finally {
            setLoading(false);
        }
    };

    const deleteSection = async (id) => {
        if (!window.confirm('Are you sure you want to delete this section? This will also delete all contacts within it.')) {
            return;
        }
        
        setLoading(true);
        try {
            const response = await fetch(`${Base_Url}/sections/${id}`, { method: 'DELETE' });
            if (!response.ok) throw new Error('Failed to delete section');
            
            showMessage('success', 'Section deleted successfully');
            setSelectedSection(null);
            fetchSections();
        } catch (error) {
            console.error('Error deleting section:', error);
            showMessage('error', 'Failed to delete section');
        } finally {
            setLoading(false);
        }
    };

    const deleteContact = async (contactId) => {
        if (!window.confirm('Are you sure you want to delete this contact?')) {
            return;
        }
        
        setLoading(true);
        try {
            const response = await fetch(`${Base_Url}/entries/${contactId}`, { method: 'DELETE' });
            if (!response.ok) throw new Error('Failed to delete contact');
            
            showMessage('success', 'Contact deleted successfully');
            
            // Refresh the selected section with updated contacts
            if (selectedSection) {
                const updatedSection = await fetchSectionDetails(selectedSection.id);
                if (updatedSection) {
                    setSelectedSection(updatedSection);
                }
            }
            
            fetchSections();
        } catch (error) {
            console.error('Error deleting contact:', error);
            showMessage('error', 'Failed to delete contact');
        } finally {
            setLoading(false);
        }
    };

    const handleSectionSelect = async (section) => {
        setSelectedSection(section);
        setActiveTab('contacts');
        
        // Fetch full section details with contacts
        const sectionDetails = await fetchSectionDetails(section.id);
        if (sectionDetails) {
            setSelectedSection(sectionDetails);
        }
    };

    // Inline editing functions for sections
    const startEditingSection = (section) => {
        setEditingSection(section.id);
        setEditSectionForm({
            title: section.title,
            column_position: section.column_position,
            display_order: section.display_order,
            email: section.email || ''
        });
    };

    const cancelEditingSection = () => {
        setEditingSection(null);
        setEditSectionForm({
            title: '',
            column_position: 'left',
            display_order: 0,
            email: ''
        });
    };

    const updateSection = async (id) => {
        setLoading(true);
        try {
            const response = await fetch(`${Base_Url}/sections/${id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(editSectionForm)
            });
            
            if (!response.ok) throw new Error('Failed to update section');
            
            showMessage('success', 'Section updated successfully');
            setEditingSection(null);
            fetchSections();
        } catch (error) {
            console.error('Error updating section:', error);
            showMessage('error', 'Failed to update section');
        } finally {
            setLoading(false);
        }
    };

    // Inline editing functions for contacts
    const startEditingContact = (contact) => {
        setEditingContact(contact.id);
        setEditContactForm({
            name: contact.name,
            designation: contact.designation,
            landline: contact.landline,
            email: contact.email,
            display_order: contact.display_order
        });
    };

    const cancelEditingContact = () => {
        setEditingContact(null);
        setEditContactForm({
            name: '',
            designation: '',
            landline: '',
            email: '',
            display_order: 0
        });
    };

    const updateContact = async (contactId) => {
        setLoading(true);
        try {
            const response = await fetch(`${Base_Url}/entries/${contactId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...editContactForm,
                    section_id: selectedSection.id
                })
            });
            
            if (!response.ok) throw new Error('Failed to update contact');
            
            showMessage('success', 'Contact updated successfully');
            setEditingContact(null);
            
            // Refresh the selected section with updated contacts
            if (selectedSection) {
                const updatedSection = await fetchSectionDetails(selectedSection.id);
                if (updatedSection) {
                    setSelectedSection(updatedSection);
                }
            }
            
            fetchSections();
        } catch (error) {
            console.error('Error updating contact:', error);
            showMessage('error', 'Failed to update contact');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="cms-container my-4">
            <h2 className="page-title mb-4 border-bottom-0 mb-0 pb-0">
            Contact Management  <span className="highlight-title">System</span>
          </h2>
            
            {message.text && (
                <div className={`cms-alert cms-alert-${message.type === 'error' ? 'danger' : 'success'} alert-dismissible fade show`}>
                    {message.text}
                    <button type="button" className="cms-alert-close" onClick={() => setMessage({ type: '', text: '' })}></button>
                </div>
            )}
            
            {loading && (
                <div className="cms-loading text-center my-4">
                    <div className="cms-spinner" role="status">
                        <span className="cms-visually-hidden">Loading...</span>
                    </div>
                </div>
            )}
            
            <ul className="cms-nav cms-nav-tabs mb-3">
                <li className="cms-nav-item">
                    <button 
                        className={`cms-nav-link ${activeTab === 'sections' ? 'cms-active' : ''}`}
                        onClick={() => setActiveTab('sections')}
                    >
                        Sections
                    </button>
                </li>
                <li className="cms-nav-item">
                    <button 
                        className={`cms-nav-link ${activeTab === 'contacts' ? 'cms-active' : ''}`}
                        onClick={() => setActiveTab('contacts')}
                    >
                        Contacts
                    </button>
                </li>
            </ul>
            
            <div className="cms-row">
                <div className="cms-col-md-4">
                    <div className="cms-section-list">
                        {sections.map(section => (
                            <button
                                key={section.id}
                                className={`cms-section-item ${selectedSection?.id === section.id ? 'cms-active-section' : ''}`}
                                onClick={() => handleSectionSelect(section)}
                            >
                                <div className="cms-section-content">
                                    <span className="cms-section-title">{section.title}</span>
                                    <div className="cms-section-badges">
                                        <span className="cms-section-badge cms-position-badge">
                                            {section.column_position}
                                        </span>
                                        <span className="cms-section-badge cms-contact-count-badge">
                                            {section.contacts_count || 0} contacts
                                        </span>
                                        {section.email && (
                                            <span className="cms-section-badge cms-email-badge" title={section.email}>
                                                📧
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </button>
                        ))}
                    </div>
                    
                    {activeTab === 'sections' && (
                        <div className="cms-section-form mt-3">
                            <h4 className="cms-form-title">Add New Section</h4>
                            <form onSubmit={handleSectionSubmit}>
                                <div className="cms-form-group">
                                    <label className="cms-form-label">Title *</label>
                                    <input
                                        type="text"
                                        className="cms-form-control"
                                        value={sectionForm.title}
                                        onChange={(e) => setSectionForm({...sectionForm, title: e.target.value})}
                                        required
                                    />
                                </div>
                                <div className="cms-form-group">
                                    <label className="cms-form-label">Column Position</label>
                                    <select
                                        className="cms-form-select"
                                        value={sectionForm.column_position}
                                        onChange={(e) => setSectionForm({...sectionForm, column_position: e.target.value})}
                                    >
                                        <option value="left">Left</option>
                                        <option value="right">Right</option>
                                    </select>
                                </div>
                                <div className="cms-form-group">
                                    <label className="cms-form-label">Section Email</label>
                                    <input
                                        type="email"
                                        className="cms-form-control"
                                        style={{textTransform: "lowercase"}}
                                        value={sectionForm.email}
                                        onChange={(e) => setSectionForm({...sectionForm, email: e.target.value})}
                                        placeholder="Optional section email"
                                    />
                                </div>
                                {/* <div className="cms-form-group">
                                    <label className="cms-form-label">Display Order</label>
                                    <input
                                        type="number"
                                        className="cms-form-control"
                                        value={sectionForm.display_order}
                                        onChange={(e) => setSectionForm({...sectionForm, display_order: parseInt(e.target.value) || 0})}
                                    />
                                </div> */}
                                <button 
                                    type="submit" 
                                    className="cms-btn cms-btn-primary"
                                    disabled={loading}
                                >
                                    Add Section
                                </button>
                            </form>
                        </div>
                    )}
                </div>
                
                <div className="cms-col-md-8">
                    {activeTab === 'sections' && (
                        <div>
                            <h4 className="cms-manage-title">Manage Sections</h4>
                            {sections.length === 0 ? (
                                <div className="cms-info-alert">
                                    No sections found. Create your first section using the form on the left.
                                </div>
                            ) : (
                                <div className="cms-table-container">
                                    <table className="cms-table">
                                        <thead>
                                            <tr>
                                                <th>Title</th>
                                                <th>Position</th>
                                                <th>Email</th>
                                                <th>Contacts</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {sections.map(section => (
                                                <tr key={section.id}>
                                                    <td style={{fontSize:"13px"}}>
                                                        {editingSection === section.id ? (
                                                            <input
                                                                type="text"
                                                                className="cms-form-control cms-inline-input"
                                                                value={editSectionForm.title}
                                                                onChange={(e) => setEditSectionForm({...editSectionForm, title: e.target.value})}
                                                            />
                                                        ) : (
                                                            section.title
                                                        )}
                                                    </td>
                                                    <td style={{fontSize:"13px"}}>
                                                        {editingSection === section.id ? (
                                                            <select
                                                                className="cms-form-select cms-inline-select"
                                                                value={editSectionForm.column_position}
                                                                onChange={(e) => setEditSectionForm({...editSectionForm, column_position: e.target.value})}
                                                            >
                                                                <option value="left">Left</option>
                                                                <option value="right">Right</option>
                                                            </select>
                                                        ) : (
                                                            section.column_position
                                                        )}
                                                    </td>
                                                    <td style={{fontSize:"13px"}}>
                                                        {editingSection === section.id ? (
                                                            <input
                                                                type="email"
                                                                className="cms-form-control cms-inline-input"
                                                                style={{textTransform: "lowercase"}}
                                                                value={editSectionForm.email}
                                                                onChange={(e) => setEditSectionForm({...editSectionForm, email: e.target.value})}
                                                            />
                                                        ) : (
                                                            <span style={{textTransform: "lowercase"}}>
                                                                {section.email || '-'}
                                                            </span>
                                                        )}
                                                    </td>
                                                    <td style={{fontSize:"13px"}}>
                                                        <span className="cms-contact-badge">
                                                            {section.contacts_count || 0}
                                                        </span>
                                                    </td>
                                                    <td style={{fontSize:"13px"}}>
                                                        {editingSection === section.id ? (
                                                            <div className="cms-inline-actions">
                                                                <button 
                                                                    className="cms-btn cms-btn-success cms-btn-sm"
                                                                    onClick={() => updateSection(section.id)}
                                                                    disabled={loading}
                                                                >
                                                                    Save
                                                                </button>
                                                                <button 
                                                                    className="cms-btn cms-btn-secondary cms-btn-sm"
                                                                    onClick={cancelEditingSection}
                                                                    disabled={loading}
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div className="cms-inline-actions">
                                                                <button 
                                                                    className="cms-btn cms-btn-primary cms-btn-sm"
                                                                    onClick={() => startEditingSection(section)}
                                                                    disabled={loading}
                                                                >
                                                                    Edit
                                                                </button>
                                                                <button 
                                                                    className="cms-btn cms-btn-danger cms-btn-sm"
                                                                    onClick={() => deleteSection(section.id)}
                                                                    disabled={loading}
                                                                >
                                                                    Delete
                                                                </button>
                                                            </div>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    )}
                    
                    {activeTab === 'contacts' && (
                        <div>
                            {selectedSection ? (
                                <>
                                    <h4 className="cms-contact-header">
                                        Manage Contacts in: {selectedSection.title}
                                        {selectedSection.email && (
                                            <span className="cms-section-email" style={{fontSize: "14px", marginLeft: "10px", color: "#666"}}>
                                                (Email: <span style={{textTransform: "lowercase"}}>{selectedSection.email}</span>)
                                            </span>
                                        )}
                                    </h4>
                                    <div className="cms-contact-card">
                                        <div className="cms-card-header">
                                            <h5 className="cms-card-title">Add New Contact</h5>
                                        </div>
                                        <div className="cms-card-body">
                                            <form onSubmit={handleContactSubmit}>
                                                <div className="cms-form-row">
                                                    <div className="cms-form-col-6">
                                                        <label className="cms-form-label">Name *</label>
                                                        <input
                                                            type="text"
                                                            className="cms-form-control"
                                                            value={contactForm.name}
                                                            onChange={(e) => setContactForm({...contactForm, name: e.target.value})}
                                                            required
                                                        />
                                                    </div>
                                                    <div className="cms-form-col-6">
                                                        <label className="cms-form-label">Designation</label>
                                                        <input
                                                            type="text"
                                                            className="cms-form-control"
                                                            value={contactForm.designation}
                                                            onChange={(e) => setContactForm({...contactForm, designation: e.target.value})}
                                                        />
                                                    </div>
                                                    <div className="cms-form-col-6">
                                                        <label className="cms-form-label">Landline</label>
                                                        <input
                                                            type="text"
                                                            className="cms-form-control"
                                                            value={contactForm.landline}
                                                            onChange={(e) => setContactForm({...contactForm, landline: e.target.value})}
                                                        />
                                                    </div>
                                                    <div className="cms-form-col-6">
                                                        <label className="cms-form-label">Email</label>
                                                        <input
                                                            type="email"
                                                            style={{textTransform: "lowercase"}}
                                                            className="cms-form-control"
                                                            value={contactForm.email}
                                                            onChange={(e) => setContactForm({...contactForm, email: e.target.value})}
                                                        />
                                                    </div>
                                                    {/* <div className="cms-form-col-6">
                                                        <label className="cms-form-label">Display Order</label>
                                                        <input
                                                            type="number"
                                                            className="cms-form-control"
                                                            value={contactForm.display_order}
                                                            onChange={(e) => setContactForm({...contactForm, display_order: parseInt(e.target.value) || 0})}
                                                        />
                                                    </div> */}
                                                    <div className="cms-form-col-12">
                                                        <button 
                                                            type="submit" 
                                                            className="cms-btn cms-btn-primary"
                                                            disabled={loading}
                                                        >
                                                            Add Contact
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                    
                                    <h5 className="cms-existing-contacts">Existing Contacts</h5>
                                    {selectedSection.contacts && selectedSection.contacts.length === 0 ? (
                                        <div className="cms-info-alert">
                                            No contacts in this section yet. Add your first contact using the form above.
                                        </div>
                                    ) : (
                                        <div className="cms-table-container">
                                            <table className="cms-table">
                                                <thead>
                                                    <tr style={{fontSize:"13px"}}>
                                                        <th>Name</th>
                                                        <th>Designation</th>
                                                        <th>Landline</th>
                                                        <th style={{textTransform: "lowercase"}}>Email</th>
                                                        <th>Order</th>
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {selectedSection.contacts && selectedSection.contacts.map(contact => (
                                                        <tr key={contact.id} style={{fontSize:"13px"}}>
                                                            <td style={{fontSize:"13px"}}>
                                                                {editingContact === contact.id ? (
                                                                    <input
                                                                        type="text"
                                                                        className="cms-form-control cms-inline-input"
                                                                        value={editContactForm.name}
                                                                        onChange={(e) => setEditContactForm({...editContactForm, name: e.target.value})}
                                                                    />
                                                                ) : (
                                                                    contact.name
                                                                )}
                                                            </td>
                                                            <td style={{fontSize:"13px"}}>
                                                                {editingContact === contact.id ? (
                                                                    <input
                                                                        type="text"
                                                                        className="cms-form-control cms-inline-input"
                                                                        value={editContactForm.designation}
                                                                        onChange={(e) => setEditContactForm({...editContactForm, designation: e.target.value})}
                                                                    />
                                                                ) : (
                                                                    contact.designation || '-'
                                                                )}
                                                            </td>
                                                            <td style={{fontSize:"13px"}}>
                                                                {editingContact === contact.id ? (
                                                                    <input
                                                                        type="text"
                                                                        className="cms-form-control cms-inline-input"
                                                                        value={editContactForm.landline}
                                                                        onChange={(e) => setEditContactForm({...editContactForm, landline: e.target.value})}
                                                                    />
                                                                ) : (
                                                                    contact.landline || '-'
                                                                )}
                                                            </td>
                                                            <td style={{fontSize:"13px"}}>
                                                                {editingContact === contact.id ? (
                                                                    <input
                                                                        type="email"
                                                                        style={{textTransform: "lowercase"}}
                                                                        className="cms-form-control cms-inline-input"
                                                                        value={editContactForm.email}
                                                                        onChange={(e) => setEditContactForm({...editContactForm, email: e.target.value})}
                                                                    />
                                                                ) : (
                                                                    <span style={{textTransform: "lowercase"}}>
                                                                        {contact.email || '-'}
                                                                    </span>
                                                                )}
                                                            </td>
                                                            <td style={{fontSize:"13px"}}>
                                                                {editingContact === contact.id ? (
                                                                    <input
                                                                        type="number"
                                                                        className="cms-form-control cms-inline-input"
                                                                        value={editContactForm.display_order}
                                                                        onChange={(e) => setEditContactForm({...editContactForm, display_order: parseInt(e.target.value) || 0})}
                                                                    />
                                                                ) : (
                                                                    contact.display_order
                                                                )}
                                                            </td>
                                                            <td style={{fontSize:"13px"}}>
                                                                {editingContact === contact.id ? (
                                                                    <div className="cms-inline-actions">
                                                                        <button 
                                                                            className="cms-btn cms-btn-success cms-btn-sm"
                                                                            onClick={() => updateContact(contact.id)}
                                                                            disabled={loading}
                                                                        >
                                                                            Save
                                                                        </button>
                                                                        <button 
                                                                            className="cms-btn cms-btn-secondary cms-btn-sm"
                                                                            onClick={cancelEditingContact}
                                                                            disabled={loading}
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    </div>
                                                                ) : (
                                                                    <div className="cms-inline-actions">
                                                                        <button 
                                                                            className="cms-btn cms-btn-primary cms-btn-sm"
                                                                            onClick={() => startEditingContact(contact)}
                                                                            disabled={loading}
                                                                        >
                                                                            Edit
                                                                        </button>
                                                                        <button 
                                                                            className="cms-btn cms-btn-danger cms-btn-sm"
                                                                            onClick={() => deleteContact(contact.id)}
                                                                            disabled={loading}
                                                                        >
                                                                            Delete
                                                                        </button>
                                                                    </div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className="cms-info-alert">
                                    Please select a section from the left to manage its contacts.
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ContactManagementSystem;